
const pacoteGridConfig = {
  idField: "idAgendamento",
  serviceMethod: "getPacotes",
  columns: [
    { header: "Cod", field: "IDAGENDAMENTO" },
    { header: "Data", field: "DATA" },
    { header: "Horário", field: "HORARIO", 
      formatter: (value) => value !== null && value !== undefined
        ? `${(value).slice(0,5)} h` : "-"
    },
    { header: "Especialidade", field: "DESCRICAO" },
    { header: "Cliente", field: "NOME" }, 
    { header: "Status", field: "STATUS" }
  ]
};

export default pacoteGridConfig;